export default __webpack_public_path__ + "static/media/alerttrue.32aecbc3.svg";